import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { SmoothScroll } from "@/components/layout/SmoothScroll";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { PreviewStrip } from "@/components/layout/PreviewStrip";
import { PublicHeader } from "@/components/layout/PublicHeader";
import { SlimFooter } from "@/components/layout/SlimFooter";
import ComingSoon from "@/pages/ComingSoon";
import Home from "@/pages/Home";
import Capabilities from "@/pages/Capabilities";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import About from "@/pages/About";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import NotFound from "@/pages/NotFound";

const PREVIEW_PATH = process.env.REACT_APP_PREVIEW_PATH;
const path = window.location.pathname;
const isPreview = Boolean(PREVIEW_PATH) && (path === PREVIEW_PATH || path.startsWith(`${PREVIEW_PATH}/`));

const PreviewSite = () => (
  <BrowserRouter basename={PREVIEW_PATH}>
    <SmoothScroll />
    <PreviewStrip />
    <Navbar />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/capabilities" element={<Capabilities />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/:slug" element={<ProjectDetail />} />
      <Route path="/about" element={<About />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    <Footer />
  </BrowserRouter>
);

const PublicPrivacy = () => (
  <>
    <PublicHeader />
    <Privacy />
    <SlimFooter />
  </>
);

const PublicSite = () => (
  <BrowserRouter>
    <SmoothScroll />
    <Routes>
      <Route path="/" element={<ComingSoon />} />
      <Route path="/privacy" element={<PublicPrivacy />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);

function App() {
  return (
    <MotionConfig reducedMotion="user">
      {isPreview ? <PreviewSite /> : <PublicSite />}
      <Toaster position="bottom-right" theme="light" />
    </MotionConfig>
  );
}

export default App;
